import { Component, Inject, OnInit } from '@angular/core';
import { ReglamentoInternoAdminComponent } from '../../reglamento-interno-admin/reglamento-interno-admin.component';

@Component({
  selector: 'app-simulacion-reglamento-interno',
  templateUrl: './simulacion-reglamento-interno.component.html',
  styleUrls: ['./simulacion-reglamento-interno.component.css']
})
export class SimulacionReglamentoInternoComponent implements OnInit {

  constructor(
    @Inject(ReglamentoInternoAdminComponent) private parent: ReglamentoInternoAdminComponent
  ) { }

  ngOnInit(): void {
  }

  volver(){
    this.parent.ngOnInit();
  }

}
